import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageCircleIcon, MailIcon, ClockIcon, UserIcon, FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, AtSignIcon, MusicIcon, CheckCircleIcon } from 'lucide-react';
import { SectionDivider } from '../components/SectionDivider';
const socials = [{
  icon: FacebookIcon,
  href: 'https://www.facebook.com/andreea.saveli',
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  href: 'https://www.instagram.com/andreeasaveli/',
  label: 'Instagram'
}, {
  icon: AtSignIcon,
  href: 'https://www.threads.com/@andreeasaveli',
  label: 'Threads'
}, {
  icon: LinkedinIcon,
  href: 'https://www.linkedin.com/search/results/all/?keywords=Andreea%20saveli&origin=GLOBAL_SEARCH_HEADER',
  label: 'LinkedIn'
}, {
  icon: YoutubeIcon,
  href: 'https://www.youtube.com/@andreeasaveli',
  label: 'YouTube'
}, {
  icon: MusicIcon,
  href: 'https://www.tiktok.com/@andreeasaveli',
  label: 'TikTok'
}];
const tellMe = ['Numele tău', 'Domeniul în care ai nevoie de ajutor: divorț, partaj, moștenire, ordin de protecție sau altceva', 'O propoziție scurtă despre situația ta, ca să mă pot pregăti înainte de sesiune'];
export function Contact() {
  return <div className="w-full" data-id="element-312">
      {/* TITLU ȘI INVITAȚIE */}
      <section className="bg-navy diagonal-pattern py-24 px-6" data-id="element-313">
        <div className="max-w-3xl mx-auto text-center" data-id="element-314">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-315">
            <h1 className="text-text-light font-heading text-5xl md:text-6xl font-bold mb-6" data-id="element-316">
              CONTACT
            </h1>
            <p className="text-text-light-secondary font-body text-lg leading-relaxed" data-id="element-317">
              Sunt aici și îți răspund direct. Dacă ai o întrebare despre
              situația ta juridică sau vrei să rezervi Sesiunea de Claritate,
              mai jos ai toate modalitățile de a mă contacta.
            </p>
          </motion.div>
        </div>
      </section>

      {/* REZERVĂ SESIUNEA */}
      <section className="bg-cream py-20 px-6" data-id="element-318">
        <div className="max-w-3xl mx-auto" data-id="element-319">
          <h2 className="text-text-dark font-heading text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-320">
            Rezervă Sesiunea de Claritate Juridică
          </h2>
          <p className="text-text-dark-secondary font-body text-lg leading-relaxed text-center mb-8" data-id="element-321">
            Cel mai rapid mod este să mă contactezi direct. Te rog să îmi spui:
          </p>

          <div className="bg-white rounded-lg p-8 border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)] mb-10" data-id="element-322">
            <ul className="space-y-4" data-id="element-323">
              {tellMe.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-324">
                  <CheckCircleIcon className="w-5 h-5 text-emerald flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-325" />
                  <span className="font-body text-base text-text-dark-secondary leading-relaxed" data-id="element-326">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-327">
            <a href="tel:+40726719788" className="inline-flex items-center justify-center gap-2 bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-328">
              <PhoneIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-329" />
              Sună acum
            </a>
            <a href="https://wa.me/40726719788" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-emerald text-white px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-emerald/90 transition-colors" data-id="element-330">
              <MessageCircleIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-331" />
              Scrie-mi pe WhatsApp
            </a>
          </div>
          <p className="text-center text-text-dark-secondary font-body text-sm mt-4" data-id="element-332">
            Apăsând pe butoane se va deschide aplicația de telefon sau WhatsApp.
          </p>
        </div>
      </section>

      <div className="bg-cream" data-id="element-333">
        <SectionDivider data-id="element-334" />
      </div>

      {/* DATE DE CONTACT */}
      <section className="bg-cream py-20 px-6" data-id="element-335">
        <div className="max-w-4xl mx-auto" data-id="element-336">
          <div className="bg-white rounded-lg p-8 md:p-10 border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)]" data-id="element-337">
            <div className="flex items-center gap-4 mb-8 pb-8 border-b border-gray-100" data-id="element-338">
              <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-339">
                <UserIcon className="w-7 h-7 text-gold" strokeWidth={1.5} data-id="element-340" />
              </div>
              <div data-id="element-341">
                <div className="font-heading text-2xl font-bold text-text-dark" data-id="element-342">
                  Andreea Saveli
                </div>
                <div className="text-gold font-label text-[10px] uppercase tracking-label" data-id="element-343">
                  Avocat Dreptul Familiei · Divorț · Partaj · Moșteniri
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 mb-8" data-id="element-344">
              <a href="tel:+40726719788" className="flex items-center gap-3 text-text-dark-secondary hover:text-emerald transition-colors" data-id="element-345">
                <PhoneIcon className="w-5 h-5 text-emerald flex-shrink-0" strokeWidth={1.5} data-id="element-346" />
                <span className="font-body" data-id="element-347">+40 726 719 788</span>
              </a>
              <a href="mailto:office@asistenta-juridica.ro" className="flex items-center gap-3 text-text-dark-secondary hover:text-emerald transition-colors" data-id="element-348">
                <MailIcon className="w-5 h-5 text-emerald flex-shrink-0" strokeWidth={1.5} data-id="element-349" />
                <span className="font-body" data-id="element-350">office@asistenta-juridica.ro</span>
              </a>
              <div className="flex items-center gap-3 text-text-dark-secondary sm:col-span-2" data-id="element-351">
                <ClockIcon className="w-5 h-5 text-emerald flex-shrink-0" strokeWidth={1.5} data-id="element-352" />
                <span className="font-body" data-id="element-353">Luni – Vineri, 08:00 – 18:00</span>
              </div>
            </div>

            <div className="pt-8 border-t border-gray-100" data-id="element-354">
              <h3 className="font-label text-sm uppercase tracking-label text-text-dark mb-4" data-id="element-355">
                Rețele sociale
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-356">
                {socials.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="w-11 h-11 rounded-full border border-emerald/30 flex items-center justify-center text-emerald hover:bg-emerald hover:text-white transition-colors" data-id="element-357">
                    <s.icon className="w-5 h-5" strokeWidth={1.5} data-id="element-358" />
                  </a>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}